import { Select } from "@tellescope/design-system";
import { forwardRef } from "react";
import { TimezoneSelectItem } from "./TimezoneSelectItem";

export const TimezoneSelectContent = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <Select.Content ref={ref}>
      <TimezoneSelectItem timezone="America/New_York" />
      <TimezoneSelectItem timezone="America/Chicago" />
      <TimezoneSelectItem timezone="America/Denver" />
      <TimezoneSelectItem timezone="America/Los_Angeles" />
      <TimezoneSelectItem timezone="America/Juneau" />
      <TimezoneSelectItem timezone="Pacific/Honolulu" />
      <TimezoneSelectItem timezone="GMT" />
      <TimezoneSelectItem timezone="CET" />
      <TimezoneSelectItem timezone="Asia/Shanghai" />
      <TimezoneSelectItem timezone="JST" />
      <TimezoneSelectItem timezone="Australia/Sydney" />
    </Select.Content>
  );
});
